export const addressSelectionGuide = {
  "addressSelectionguide.get": "addressSelectionguide.get",
  "addressselectionguide.edit": "addressselectionguide.edit",
  "addressselectionguide.create": "addressselectionguide.create",
} as const;
